import * as React from 'react';

export const NotFound = (): JSX.Element => {
  return <div> 404, page not found </div>;
};
